import { Checkbox } from '@design-system';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';

import { DetailsAddress } from '../types';
import { SavedAddressCard } from './SavedAddressCard';

export type ShippingAddressSectionProps = {
  /** The pre-selected saved address. When absent, the inline form is shown instead. */
  selectedAddress?: DetailsAddress;
  /** Stripe `AddressElement`, injected by the wrapper. */
  addressFields: ReactNode;
  saveAddress: boolean;
  onSaveAddressChange: (saveAddress: boolean) => void;
  showMarketingOptIn?: boolean;
  marketingOptIn: boolean;
  onMarketingOptInChange: (marketingOptIn: boolean) => void;
  onEdit: () => void;
};

export const ShippingAddressSection = ({
  addressFields,
  marketingOptIn,
  onEdit,
  onMarketingOptInChange,
  onSaveAddressChange,
  saveAddress,
  selectedAddress,
  showMarketingOptIn = false,
}: ShippingAddressSectionProps) => {
  const { t } = useTranslation('checkout');

  return (
    <section className="flex flex-col gap-3">
      <h3 className="font-bold">{t('details.shippingAddress.title')}</h3>

      {selectedAddress ? (
        <SavedAddressCard
          address={selectedAddress}
          editLabel={t('details.shippingAddress.edit')}
          onEdit={onEdit}
        />
      ) : (
        <>
          {addressFields}

          {showMarketingOptIn && (
            <Checkbox
              checked={marketingOptIn}
              id="details-marketing-opt-in"
              label={t('details.shippingAddress.marketingOptIn')}
              name="details-marketing-opt-in"
              onChange={(e) => onMarketingOptInChange(e.currentTarget.checked)}
              type="checkbox"
            />
          )}

          <Checkbox
            checked={saveAddress}
            id="details-save-address"
            label={t('details.shippingAddress.save')}
            name="details-save-address"
            onChange={(e) => onSaveAddressChange(e.currentTarget.checked)}
            type="checkbox"
          />
        </>
      )}
    </section>
  );
};
